//Listing Featured Image + Links
var listingFeaturedImageLinks = $('.listing-featured-image-links');

if(listingFeaturedImageLinks.length > 0) {
    var listingFeaturedImageLinksItems = $('.listing-featured-image-links-items');
    listingFeaturedImageLinksItems.slick({
      dots: true,
      infinite: true,
      arrow:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
          }
        }
      ],
    });

    $(window).on('load resize changeorientaion', function() {
      $('.listing-featured-image-links-item').each(function () {
        $(this).css("background-image", "url(" + $(this).data("bg-image") + ")");
      });
    });

}

//Listing Featured Carousel

var listingFeaturedCarousel = $('.listing-featured-carousel');

if(listingFeaturedCarousel.length > 0) {
    var listingFeaturedCarouselItems = $('.listing-featured-carousel-items');
    var listingFeaturedCarouselNav = $('.listing-featured-carousel-nav');
    listingFeaturedCarouselItems.slick({
      dots: true,
      infinite: true,
      arrow:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      //asNavFor: '.listing-featured-carousel-nav'
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
          }
        }
      ],
    });

    listingFeaturedCarouselNav.slick({
     slidesToShow: 3,
     slidesToScroll: 1,
     asNavFor: '.listing-featured-carousel-items',
     dots: false,
     focusOnSelect: true,
     variableWidth: true,
    });

}

//Listing 3 Column Cards
var listing3columncards = $('.listing-3column-cards');

if(listing3columncards.length > 0) {
  var listing3columncardsItems = $('.listing-3column-cards-items');
  listing3columncardsItems.slick({
    dots: false,
    infinite: true,
    arrow:true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        }
      }
    ],
  });
  listing3columncardsItems.find('.listing-3column-cards-item').parent().addClass('slickparent');
}

//Listing Gallery Carousel
var listingGalleryCarousel = $('.listing-gallery-carousel');

if(listingGalleryCarousel.length > 0) {
    var listingGalleryCarouselItems = $('.listing-gallery-carousel-items');
    listingGalleryCarouselItems.slick({
      dots: true,
      infinite: true,
      arrow:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
    });

}

//Listing Feature Article Large
var listingFeaturedArticle = $('.listing-featured-article-large');

if(listingFeaturedArticle.length > 0) {
    var listingFeaturedArticleItems = $('.listing-featured-article-large .listing-featured-article-items');
    listingFeaturedArticleItems.slick({
      dots: true,
      infinite: true,
      arrow:true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

}

var listingFeaturedDownloadItem = $('.listing-featured-download-documents');
if (listingFeaturedDownloadItem.length > 0) {
  var listingFeaturedDownloadItems = $('.listing-featured-download-documents .listing-featured-download-items');
  listingFeaturedDownloadItems.slick({
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,

        }
      }
    ],
  });
  $(window).on('load resize orientationchange', function () {
    if ($(window).width() > 768) {
      if (listingFeaturedDownloadItems.hasClass('slick-initialized')) {
        listingFeaturedDownloadItems.slick('unslick');
      }
    }
    else {
      if (!listingFeaturedDownloadItems.hasClass('slick-initialized')) {
        listingFeaturedDownloadItems.slick({
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
        });
      }
    }
  });
}

//Listing Icon Card
var listingIconCard = $('.listing-icon-card');

function listingIconCardInit() {
  var icontitledescriptiontop = $('.icon-title-description-top');
  icontitledescriptiontop.css('height','auto');
  var maxHeight = null;
  icontitledescriptiontop.each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  icontitledescriptiontop.each(function() {
    $(this).height(maxHeight);
  });
}

if(listingIconCard.length > 0) {
  if (window.innerWidth>= 768) {
    listingIconCardInit();
  }
  $(window).resize(function () {
    if (window.innerWidth >= 768) {
      listingIconCardInit();
    }
  });
}

//Listing Country Cards
var listingcountrycards = $('.listing-country-cards');

function listingcountrycardsInit() {
  var countrydetailtop = $('.country-detail-top');
  var countrysimpletitle = $('.country-simple-title');
  countrydetailtop.css('height','auto');
  countrysimpletitle.css('height','auto');
  var maxHeight = null;
  var maxHeight2 = null;
  countrydetailtop.each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  countrydetailtop.each(function() {
    $(this).height(maxHeight);
  });
  countrysimpletitle.each(function() {
    maxHeight2 = maxHeight2 > $(this).height() ? maxHeight2 : $(this).height();
  });
  countrysimpletitle.each(function() {
    $(this).height(maxHeight2);
  });
}

if(listingcountrycards.length > 0) {
  listingcountrycardsInit();
  $(window).resize(function () {
    listingcountrycardsInit();
  });
}

//Listing Featured Download
var listingfeatureddownload = $('.listing-featured-download');

function listingfeatureddownloadInit() {
  var documentcardtitle = $('.document-card-title');
  documentcardtitle.css('height','auto');
  var maxHeight = null;
  documentcardtitle.each(function() {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  documentcardtitle.each(function() {
    $(this).height(maxHeight);
  });
}

if(listingfeatureddownload.length > 0) {
  listingfeatureddownloadInit();
  $(window).resize(function () {
    listingfeatureddownloadInit();
  });
}

// listing icon
var listingIcon = $('.listing-icon-bottom .listing-icon-items');
if (listingIcon.length > 0) {
  var listingIconCTA = $('.listing-icon-inner .title-description-cta-cta');
  var listingIconCtaCopy = listingIconCTA.clone();
  $(window).on('load resize orientationchange', function () {
    if ($(window).width() > 768) {
      if (listingIcon.hasClass('slick-initialized')) {
        listingIcon.slick('unslick');
      }
      $(document).find('.listing-icon-bottom .title-description-cta-cta').remove();
    }
    else {
      listingIconCtaCopy.appendTo('.listing-icon-bottom').show();
      if (!listingIcon.hasClass('slick-initialized')) {
        listingIcon.slick({
          dots: true,
          infinite: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
        });
      }
    }
  });
}